export const roundSeries = series => {
	return series.map(currentSeries => ({
		...currentSeries,
		data: currentSeries.data.map(seriesPoint => ({
			...seriesPoint,
			y: seriesPoint.y === null || seriesPoint.y === undefined ? seriesPoint.y : Number(seriesPoint.y.toFixed(2)),
		})),
	}))
}
